import { render, staticRenderFns } from "./SubscriptionRestricted.html?vue&type=template&id=2ea48f2a&"
import script from "./SubscriptionRestricted.js?vue&type=script&lang=js&"
export * from "./SubscriptionRestricted.js?vue&type=script&lang=js&"
import style0 from "./SubscriptionRestricted.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports